import type { Redirect } from '../types/Redirect';

export const useRedirectsStore = defineStore('redirects', ()=> {
    const redirects = ref<null | Redirect[]>(null);

    return {
        redirects,
    };
});
